import React from 'react';
import { getClassNames } from '@RHEnvironmental/pattern-library/dist/js/services/stylingUtils';

const Card = ({ children, className }) => {
    const classNames = getClassNames(className, { card: true });

    return <div className={classNames}>{children}</div>;
};

export default Card;
